import axios from 'axios';
import type { AnsweringSubscriptionJsonType } from '@bb/domain/dist/types';

export type CreateAnsweringSubscriptionInput = Pick<
  AnsweringSubscriptionJsonType,
  | 'userId'
  | 'startDate'
  | 'subscriptionLevel'
  | 'answeringServicePhone'
  | 'answeringServiceId'
  | 'stripeCustomerId'
  | 'defaultEnabled'
  | 'serviceType'
> & {
  coverageType: string;
};

const createAnsweringSubscription = async (
  body: CreateAnsweringSubscriptionInput,
) => {
  await axios.post<CreateAnsweringSubscriptionInput>(
    '/answering_subscription',
    body,
  );
};

export default createAnsweringSubscription;
